<template>
	<div>
		<el-form :inline="true">
			<el-form-item label="搜索">
				<el-input v-model="keyword" placeholder="按名称搜索" maxlength="150" clearable>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="info" @click="query">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="handleAdd">新建</el-button>
			</el-form-item>
		</el-form>

		<el-table :data="tableData" size="mini" :height="screenHeight - 500 + 'px'" :row-class-name="tableRowClassName">
			<el-table-column type="index" label="序号" width="50"></el-table-column>
			<el-table-column prop="name" label="工序名称"></el-table-column>
			<el-table-column label="进料方向" width="150">
				<template slot-scope="scope">
					<span v-text="getDirectionName(scope.row.is_end_in)"></span>
				</template>
			</el-table-column>
			<el-table-column label="编辑" width="150">
				<template slot-scope="scope">
					<div>
						<el-button type="text" icon="el-icon-edit" v-on:click="edit(scope.row)">编辑</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-popconfirm title="确定删除吗？" @onConfirm="remove(scope.row)">
							<el-button type="text" icon="el-icon-delete" slot="reference">删除</el-button>
						</el-popconfirm>
					</div>
				</template>
			</el-table-column>

			<el-table-column label="选择" width="100">
				<template slot-scope="scope">
					<div v-if="checkSelected(scope.row)">
						<el-button type="text" icon="el-icon-remove-outline" v-on:click="handleCancel(scope.row)">取消选择</el-button>
					</div>
					<div v-else>
						<el-button type="text" icon="el-icon-circle-plus-outline" v-on:click="handleSelect(scope.row)">选择</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 编辑工序信息  -->
		<el-dialog :title="formDialogTitle" :visible.sync="formDialogVisable" width="500px" append-to-body>
			<div>
				<el-form ref="processForm" :rules="rules" :model="form" label-position="right" label-width="80px">
					<el-form-item label="工序名称" prop="name" clearable>
						<el-input v-model.trim="form.name" placeholder="工序名称" maxlength="150" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="进料方向" prop="is_end_in">
						<el-select v-model.trim="form.is_end_in" placeholder="进料方向">
							<el-option v-for="item in directionItems" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formDialogVisable = false">取消</el-button>
				<el-button type="primary" :loading="saving" v-on:click="save('processForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { processDirections, getDirectionName, processInfoRequest } from '@/network/requests/processInfo'
	export default {
		props: {
			items: {
				type: Array,
			},
			details: {
				type: Array,
			},
		},
		data() {
			/**
			 * 工序重名检查(必须名称和进料方向同时满足条件)。
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入工序名称'))
				} else {
					var msg = '相同进料顺序的工序名称已经存在，请更换名称。'
					//检查名称是否重复。
					processInfoRequest.queryAll({ name: value, is_end_in: this.form.is_end_in }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]

							if (this.form._id) {
								if (data._id.$oid != this.form._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}

			return {
				directionItems: [],
				keyword: '',
				formDialogVisable: false,
				formDialogTitle: '编辑工序',
				form: {},
				rules: {
					name: [
						{ required: true, message: '请输入工序名称', trigger: 'change' },
						{ validator: validateExist, trigger: 'blur' },
					],
					is_end_in: [{ required: true, message: '请选择进料方向', trigger: 'change' }],
				},
				screenWidth: 0,
				screenHeight: 0,
				tableData: [],
				saving: false,
			}
		},
		watch: {
			items: {
				handler(val, oldVal) {
					this.tableData = val
				},
				deep: true,
			},
		},
		computed: {},
		methods: {
			/**
			 * 选中行，样式处理。
			 */
			tableRowClassName({ row, rowIndex }) {
				var first = this.details.find(t => t.process_id == row._id.$oid)
				if (first) {
					return 'success-row'
				}
				return ''
			},
			/**
			 * 判断是否选中
			 */
			checkSelected(row) {
				var first = this.details.find(t => t.process_id == row._id.$oid)
				if (first) {
					return true
				}

				return false
			},
			/**
			 * 添加。
			 */
			handleAdd() {
				this.formDialogTitle = '添加新工序'
				this.formDialogVisable = true
				this.form = {
					is_end_in: 0,
				}
			},
			/**
			 * 保存工序
			 */
			save(formName) {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				this.$refs[formName].validate(valid => {
					if (valid) {
						var model = this.form
						var p = undefined
						if (model._id) {
							p = processInfoRequest.modifyById(model._id.$oid, model)
						} else {
							p = processInfoRequest.upload(model)
						}

						p.then(res => {}).finally(() => {
							this.$emit('saved')
							this.saving = false
						})

						this.formDialogVisable = false
					} else {
						this.saving = false
						return false
					}
				})
			},
			/**
			 * 删除。
			 */
			remove(row) {
				this.$emit('remove', row)
				this.query()
			},
			/**
			 * 编辑。
			 */
			edit(row) {
				this.form = { ...row }
				this.formDialogTitle = '编辑工序'
				this.formDialogVisable = true
			},
			/**
			 * 获取进料方向名称。
			 */
			getDirectionName(val) {
				return getDirectionName(val)
			},
			/**
			 * 取消选中。
			 */
			handleCancel(row) {
				this.$emit('cancel', row)
			},
			/**
			 * 选中。
			 */
			handleSelect(row) {
				this.$emit('select', row)
			},
			/**
			 * 搜索。
			 */
			query() {
				if (this.keyword) {
					this.tableData = this.items.filter(t => t.name.indexOf(this.keyword) > -1)
				} else {
					this.tableData = this.items
				}
			},
		},
		mounted() {
			this.screenWidth = document.body.clientWidth
			this.screenHeight = document.body.clientHeight
			window.onresize = () => {
				return (() => {
					this.screenWidth = document.body.clientWidth
					this.screenHeight = document.body.clientHeight
				})()
			}
		},
		created() {
			this.directionItems = processDirections
			this.tableData = this.items
		},
	}
</script>
